(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordian"] && !window.DesignMode) return;
  try {
    
  const accordianTitleEle = document.getElementsByClassName("accordian-title");
  const contentEle = document.getElementsByClassName("accordian-content");
  const arrowEle = document.getElementsByClassName("accordian-arrow");

  for(let i=0; i<=accordianTitleEle.length-1; i++){
    accordianTitleEle[i].addEventListener("click", () => {
      if(contentEle[i].clientHeight>0){
        contentEle[i].style.height=`0px`
        contentEle[i].style.marginBottom=`0px`
      }
      else{
        contentEle[i].style.height=`${contentEle[i].scrollHeight}px`
        contentEle[i].style.marginBottom=`10px`
      }
      arrowEle[i].classList.toggle("accordian-arrow-rotate");
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["available-on"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
  $(".available-on-carousel").owlCarousel({
      margin: 15,
      dots: true,
      responsive:{
         0:{
              items:3,
          },
          768:{
              items:4,
          },
          
      }
  });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-category"] && !window.DesignMode) return;
  try {
    
  // $(document).ready(function(){
      $(".categories-product-slider").owlCarousel({
        items: 3,
        margin: 30,
        responsive:{
          0:{
              stagePadding: 40,
              margin: 16,
              items:1,
          },
          768:{
              items:3,
              nav: true
          },
            1900:{
              items:5,
          },
        }
      });
  // });

      // // logic for active tabs
      const tabs = document.getElementsByClassName("bestseller-tab")
      const collections = document.getElementsByClassName("bestseller-collection");

      if(collections.length>0){
        collections[0].style.display="block"
      }
      if(tabs.length>0){
        tabs[0].classList.add("active-bestseller-tab");
      }

      for(let tab=0; tab<=tabs.length-1; tab++){
        tabs[tab].addEventListener("click", (tabElement)=>{
          tabElement.preventDefault();
          const clickedTab = tab

            for(let collection=0; collection<=collections.length-1; collection++){
              if(collection==clickedTab){
                tabs[collection].classList.add("active-bestseller-tab");
                collections[collection].style.display="block"
              }
              else{
                tabs[collection].classList.remove("active-bestseller-tab");
                collections[collection].style.display="none"
              }
            }
        })
      }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-banner-carousel"] && !window.DesignMode) return;
  try {
    
  // $(window).on('load', function(){
     $(".custom-hero-banner-slider").owlCarousel({
       loop: true,
       nav: false,
       dots: true,
      autoplay: true,
     autoplayTimeout: 4000,
     autoplayHoverPause: true,
     smartSpeed: 1000,
       responsive: {
         0: {
           items: 1
         }
       }
     });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-category-list"] && !window.DesignMode) return;
  try {
    
  // $(document).ready(function(){
      $(".custom-category-list-carousel").owlCarousel({
        items: 4,
        margin: 30,
        responsive:{
          0:{
              stagePadding: 30,
              items:1,
              nav: false,
              margin: 16,
          },
          768:{
              items:4,
              nav: true,
          },
            1900:{
              items:5,
          },
        }
      });
  // 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-list-2"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
    // $(".custom-collection-carousel").owlCarousel({
    //   margin:15,
    //   responsive:{
    //     0:{
    //       items: 3
    //     },
    //     768:{
    //       items:4
    //     }
    //   }
    // });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-list"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
    // $(".custom-collection-carousel").owlCarousel({
    //   margin:15,
    //   responsive:{
    //     0:{
    //       items: 3
    //     },
    //     768:{
    //       items:4
    //     }
    //   }
    // });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doctor-reviews-product"] && !window.DesignMode) return;
  try {
    
  // $(document).ready(function(){
  $(".doctor-reviews-product-slider").owlCarousel({
    stagePadding: 100,
    loop:true,
    margin:30,
   autoplay:true,
    autoplayTimeout:3000,
    smartSpeed: 400,
    responsive:{
        0:{
          items:1,
          stagePadding: 50,
        },
      768:{
          items:2,
        stagePadding: 50,
        },
      1024:{
          items:3,
        stagePadding: 50,
        }
    }
  });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doctor-reviews"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
    $(".doctor-reviews-slider").owlCarousel({
      items: 3,
      stagePadding: 50,
      margin: 30,
      autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      responsive:{
          0:{
              items:1,
          },
          768:{
              items:2,
          },
         1024:{
              items:3,
          },
      }
    });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  const accordianTitleEle = document.getElementsByClassName("accordion-toggle");
  const contentEle = document.getElementsByClassName("accordion-content");

  for(let i=0; i<=accordianTitleEle.length-1; i++){
    accordianTitleEle[i].addEventListener("click", () => {
      if(contentEle[i].clientHeight>0){
        contentEle[i].style.height=`0px`
        contentEle[i].style.marginBottom=`0px`
      }
      else{
        contentEle[i].style.height=`${contentEle[i].scrollHeight}px`
        contentEle[i].style.marginBottom=`40px`
      }
      accordianTitleEle[i].classList.toggle("product-accordian-title-rotate");
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
  $(".goole-reviews-carousel").owlCarousel({
      margin: 15,
      nav: true,
      dots: false,
      responsive:{
        0: {
          items: 1
        },
            768 : {
          items: 3
        }
      }
  });
  // });

  const readMoreBtns = document.querySelectorAll(".read-more-btn")
  var shortText = document.querySelectorAll('.short-text');
  var fullText = document.querySelectorAll('.full-text');
  
  readMoreBtns.forEach((readMoreBtn, index)=>{
    readMoreBtn.addEventListener("click", ()=>{
      console.log(readMoreBtn)
      if (fullText[index].style.display === 'none') {
        fullText[index].style.display = 'inline';
        shortText[index].style.display = 'none';
        readMoreBtn.textContent = 'Read less';
      } else {
        fullText[index].style.display = 'none';
        shortText[index].style.display = 'inline';
        readMoreBtn.textContent = 'Read more';
      }
    })
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-help-product"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $(".how-it-works-product-slider").owlCarousel({
      loop: true,
      responsiveClass: true,
      nav: false,
      margin: 26,
      autoplay:true,
      autoplayTimeout:3000,
      smartSpeed: 400,
      center: true,
      responsive:{
        0: {
          stagePadding: 20,
          items: 1,
          margin: 15,
        },
        768: {
          items: 3,
          stagePadding: 20,
        },
           1024: {
          items: 4,
          stagePadding: 20,
        }
      }
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
    $(".image-gallery-slider").owlCarousel({
      items: 4,
      margin: 30,
      loop:true,
      autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
       center: true,
      responsive:{
          0:{
              stagePadding: 50,
              items:1.2,
          },
          600:{
              stagePadding: 50,
              items:3,
          }
      }
    });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-image"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
    $(".payment-image-slider").owlCarousel({
      items: 4,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
    });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $(".press-slider").owlCarousel({
    items: 4,
    margin: 30
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordian-description"] && !window.DesignMode) return;
  try {
    
  const accordianTitleEle = document.getElementsByClassName("product-accordian-title");
  const contentEle = document.getElementsByClassName("product-accordian-content");

  for(let i=0; i<=accordianTitleEle.length-1; i++){
    accordianTitleEle[i].addEventListener("click", () => {
      if(contentEle[i].clientHeight>0){
        contentEle[i].style.height=`0px`
        contentEle[i].style.marginBottom=`0px`
      }
      else{
        contentEle[i].style.height=`${contentEle[i].scrollHeight}px`
        contentEle[i].style.marginBottom=`10px`
      }
      accordianTitleEle[i].classList.toggle("product-accordian-title-rotate");
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !window.DesignMode) return;
  try {
    
  const accordianTitleEle = document.getElementsByClassName("accordion-toggle");
  const contentEle = document.getElementsByClassName("accordion-content");

  for(let i=0; i<=accordianTitleEle.length-1; i++){
    accordianTitleEle[i].addEventListener("click", () => {
      if(contentEle[i].clientHeight>0){
        contentEle[i].style.height=`0px`
        contentEle[i].style.marginBottom=`0px`
      }
      else{
        contentEle[i].style.height=`${contentEle[i].scrollHeight}px`
        contentEle[i].style.marginBottom=`10px`
      }
      accordianTitleEle[i].classList.toggle("product-accordian-title-rotate");
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !window.DesignMode) return;
  try {
    
  const accordianTitleEle = document.getElementsByClassName("accordion-toggle");
  const contentEle = document.getElementsByClassName("accordion-content");

  for(let i=0; i<=accordianTitleEle.length-1; i++){
    accordianTitleEle[i].addEventListener("click", () => {
      if(contentEle[i].clientHeight>0){
        contentEle[i].style.height=`0px`
        contentEle[i].style.marginBottom=`0px`
      }
      else{
        contentEle[i].style.height=`${contentEle[i].scrollHeight}px`
        contentEle[i].style.marginBottom=`10px`
      }
      accordianTitleEle[i].classList.toggle("product-accordian-title-rotate");
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
  $(".social-proof-owl-carousel").owlCarousel({
      items: 4,
       stagePadding: 50,
       loop:true,
       autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
     responsive:{
        0:{
            stagePadding: 0,
            items:3,
        },
        768:{
            items:3,
        },
        1024:{
            items:4,
        },
    }

  });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-reviews"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
  $(".home-user-reviews-carousel").owlCarousel({
      margin: 15,
      items: 3,
      nav: true,
      dots: false,
      responsive:{
         0:{
              items:1,
          },
          768:{
              items:2,
          },
         1024:{
              items:3,
          },
      }
  });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-inside-the-box"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $(".Whats-inside-the-box-slider").owlCarousel({
      loop:true,
      autoplay:false,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      responsive:{
         0 : {
           items: 2,
          },
        768 : {
           items: 3,
          },
        1024: {
           items: 4,
          },
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-nonu"] && !window.DesignMode) return;
  try {
    
    // $(document).ready(function(){
    $(".why-nonu-slider").owlCarousel({
      items: 1,
       loop:true,
        margin:10,
        nav:true,
        dots: true,
       responsive:{
            0:{
                items:1,
                nav:true,
            },
            600:{
                items:1,
                nav:false,
            },
            1000:{
                items:1,
              nav:false,
            }
        }
    });
  // });

  } catch(e) { console.error(e); }
})();
})();
